import React from 'react'
import Electorent from '../../assets/Electorent.jpeg'
import Appolice from '../../assets/Appolice.jpeg'
import Tribute from '../../assets/Tribute.png'
import Calculator from '../../assets/Calculator.png'
import Expense from '../../assets/Expense.png'
import './portfolio.css'

const data = [
  {
    id: 1,
    image: Electorent,
    title: "Electorent - Ecommerce app",
    github: "https://github.com/GlamorousBrusier12/fsd-project",
    demo: "https://electorent.netlify.app/"
  },
  {
    id: 2,
    image: Appolice,
    title: "FIR Filing - AP Police",
    github: "https://github.com/ravindra0608/PoliceWebsite",
    demo: "https://ap-police.herokuapp.com/"
  },
  {
    id: 3,
    image: Tribute,
    title: "Tribute - Lionel Messi",
    demo: "https://chetan639.github.io/Tribute/",
    github: "https://github.com/chetan639/Tribute"
  },
  {
    id: 4,
    image: Calculator,
    title: "Simple Calculator",
    github: "https://github.com/chetan639/Simple-Calculator",
    demo: "#portfolio"
  },
  {
    id: 5,
    image: Expense,
    title: "Expense Tracker",
    github: "https://github.com/chetan639/Expense-Tracker",
    demo: "#portfolio"
  }

]

function Portfolio() {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className='container portfolio__container'>
      {data.map((portfolio)=>{
        return <article key={portfolio.id} className='portfolio__item'>
          <div className='portfolio__item-image'>
            <img src={portfolio.image} alt='Portfolio'/>
          </div>
          <h3>{portfolio.title}</h3>
          <div className='portfolio__item-cta'>
            <a href={portfolio.github} className='btn' target='_blank' rel="noreferrer">Github</a>
            <a href={portfolio.demo} className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
          </div>
        </article>
      })}
      </div>
    </section>
  )
}

export default Portfolio